/* istanbul ignore file */
import styled from 'styled-components';
import { Input } from '@econsult/econsult-ui/dist/components/Input';
import { InputElement, InputLabel, InputMessageWrapper, InputMessage } from '@econsult/econsult-ui/dist/components/Input/InputStyles';

export const LightInput = styled(Input).attrs({ typography: 'ParagraphTinyRegular' })`
  ${InputLabel} {
    font-size: 0.75rem;
  }

  ${InputMessageWrapper} {
    padding-block: 0.125rem;
  }

  ${InputMessage} {
    font-size: 0.75rem;
  }

  & ${InputElement} {
    ${({ theme }) => theme.fontStyles};
    padding: 0.5625rem 0.75rem;

    &:not(:focus) {
      box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colorNeutralNeutral7};
    }
  }
`;
